import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';

import css from './BooksLoginRequireAlert.module.scss';

interface Props {
  className?: string;
  onClick: () => void;
}

const BooksLoginRequireAlert = ({
  className,
  intl,
  onClick,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksLoginRequireAlert, className);

  return (
    <div className={classes}>
      <p className={css.BooksLoginRequireAlert__Paragraph}>
        {intl.formatMessage({ id: 'books.forms.loginRequireAlertMessage1' })}
      </p>
      <p className={css.BooksLoginRequireAlert__Paragraph}>
        <FormattedMessage
          id="books.forms.loginRequireAlertMessage2"
          values={{
            createUser: (
              <a onClick={onClick} className={css.BooksLoginRequireAlert__Link}>
                {intl.formatMessage({ id: 'books.forms.here' })}
              </a>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default injectIntl(BooksLoginRequireAlert);
